import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Button, FormGroup, ControlLabel, FormControl, Checkbox } from 'react-bootstrap';
import { FieldGroup } from './FieldGroup';
import { Validator } from './Validator';
import { required, isEmail, isFullName, isNumeric, validateRuleMap } from '../utils/ValidatorRulesUtils';
import { AlertGenerator } from './AlertGenerator';

@observer
class CustomerFields extends Component {
  displayName = CustomerFields.name;

  constructor(props) {
    super(props);
    const initialState = props.initialState || {};
    this.state = { ...this.state, ...initialState };
  }

  state = {
    name: '',
    senderName: '',
    email: '',
    replyTo: '',
    carmaRefId: '',
    code: '',
    apiKey: '',
    smsApiKey: '',
    voiceApiKey: '',
    fromPhoneSms: '',
    fromPhoneVoice: '',
    smsProvider: 'twilio',
    voiceProvider: 'twilio',
    sendTimeEmailStart: '08:00:00',
    sendTimeEmailEnd: '20:00:00',
    sendTimeSmsStart: '08:00:00',
    sendTimeSmsEnd: '20:00:00',
    sendTimeVoiceStart: '08:00:00',
    sendTimeVoiceEnd: '20:00:00',
    organizationId: 0,
    sendgridClickTracking: true,
    sendgridOpenTracking: true,
    callRecordingsEnabled: false
  };

  componentWillUnmount() {
    if (this.props.configurationStore !== undefined) {
      this.props.configurationStore.resetCustomerUpdated();
    }
  }

  componentDidMount() {
    if (this.props.configurationStore !== undefined) {
      this.props.organizationStore.getOrganizations();
      this.props.configurationStore.resetCustomerUpdated();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.initialState === this.props.initialState)
      return;

    const initialState = this.props.initialState || {};
    this.setState({ ...this.state, ...initialState });
    const { customerUpdated } = this.props.configurationStore;
    if ((prevProps.customerUpdated !== customerUpdated) && customerUpdated)
      this.props.configurationStore.setAlert('Update completed successfully!', 'success');
  }

  updateField(name, event) {
    this.setState({
      [name]: event.target.value
    });
  }

  updateCheckbox(name, event) {
    this.setState({
      [name]: event.target.checked
    });
  }

  submit = (event) => {
    event.preventDefault();
    const validState = validateRuleMap(CustomerFields.rules, this.state);

    if (!validState) {
      this.props.configurationStore.setAlert('Some fields are invalid!', 'danger');
      return;
    }

    const organizationId = this.state.organizationId === 0 ? null : this.state.organizationId;
    this.props.onSubmit({ ...this.state, organizationId });
    this.props.closeModal && this.props.closeModal();
  };

  static rules = {
    name: [required, isFullName],
    email: [required, isEmail],
    carmaRefId: [required, isNumeric],
    code: [required, isNumeric]
  };

  render() {
    const { buttonText } = this.props;
    const { rules } = CustomerFields;
    const { alertMessage, hideAlert } = this.props.configurationStore;
    const { organizations: orgs } = this.props.organizationStore;
    return (
      <form onSubmit={this.submit}>
        <AlertGenerator alertMessage={alertMessage} hideAlert={hideAlert}></AlertGenerator>
        <Validator rules={rules.name}
          fieldName='Name' value={this.state.name} render={({ isValid, message }) => (
            <FieldGroup
              id='customerNameInput'
              type='text'
              label='Name'
              onChange={this.updateField.bind(this, 'name')}
              value={this.state.name}
              isValid={isValid}
              message={message}
              required />
          )}
        />
        <Validator rules={rules.email}
          fieldName='Email' value={this.state.email} render={({ isValid, message }) => (
            <FieldGroup
              id='customerEmailInput'
              type='text'
              label='Email'
              onChange={this.updateField.bind(this, 'email')}
              value={this.state.email}
              isValid={isValid}
              message={message}
              required />
          )}
        />
        <FieldGroup
          id='customerReplyToInput'
          type='text'
          label='Reply To'
          onChange={this.updateField.bind(this, 'replyTo')}
          value={this.state.replyTo} />
        <Validator rules={rules.name}
          fieldName='Sender Name' value={this.state.name} render={({ isValid, message }) => (
            <FieldGroup
              id='senderNameInput'
              type='text'
              label='Sender Name'
              onChange={this.updateField.bind(this, 'senderName')}
              value={this.state.senderName}
              isValid={isValid}
              message={message}
              required />
          )}
        />
        <FieldGroup
          id='customerFromPhoneSms'
          type='text'
          label='SMS Phone Number'
          onChange={this.updateField.bind(this, 'fromPhoneSms')}
          value={this.state.fromPhoneSms}
        />

        <FieldGroup
          id='customerFromPhoneVvoice'
          type='text'
          label='Voice Phone Number'
          onChange={this.updateField.bind(this, 'fromPhoneVoice')}
          value={this.state.fromPhoneVoice || ''}
        />

        <Validator rules={rules.carmaRefId}
          fieldName='Carma Id' value={this.state.carmaRefId} render={({ isValid, message }) => (
            <FieldGroup
              id='customerCarmaInput'
              type='text'
              label='Carma Id'
              onChange={this.updateField.bind(this, 'carmaRefId')}
              value={this.state.carmaRefId}
              isValid={isValid}
              message={message}
              required />
          )}
        />
        <Validator rules={rules.code}
          fieldName='Code (Bloodhound Id)' value={this.state.code} render={({ isValid, message }) => (
            <FieldGroup
              id='customerCodeInput'
              type='text'
              label='Code (Bloodhound Id)'
              onChange={this.updateField.bind(this, 'code')}
              value={this.state.code}
              isValid={isValid}
              message={message}
              disabled={this.props.initialState && this.props.initialState.code}
              required />
          )}
        />
        <FieldGroup
          id='customerApiKey'
          type='text'
          label='Sendgrid API Key (optional)'
          onChange={this.updateField.bind(this, 'apiKey')}
          value={this.state.apiKey || ''}
        />

        <FieldGroup
          id='customerSmsApiKey'
          type='text'
          label='SMS Twilio API Key - Format: AccountSid(space)AuthToken - i.e. = 12343 TVBSTAFS'
          onChange={this.updateField.bind(this, 'smsApiKey')}
          value={this.state.smsApiKey || ''}
        />

        <FormGroup controlId="smsProviderSelect" className='mt-4'>
          <ControlLabel>SMS Provider</ControlLabel>
          <FormControl componentClass="select"
            value={this.state.smsProvider || undefined}
            onChange={this.updateField.bind(this, 'smsProvider')}
          >
            <option value='twilio'>Twilio</option>
            <option value='plivo'>Plivo</option>
            <option value='telnyx'>Telnyx</option>
            <option value='bandwidth'>Bandwidth</option>
          </FormControl>
        </FormGroup>

        <FieldGroup
          id='customerVoiceApiKey'
          type='text'
          label='Voice Twilio API Key - Format: AccountSid(space)AuthToken - i.e. = 12343 TVBSTAFS'
          onChange={this.updateField.bind(this, 'voiceApiKey')}
          value={this.state.voiceApiKey || ''}
        />

        <FormGroup controlId="voiceProviderSelect" className='mt-4'>
          <ControlLabel>Voice Provider</ControlLabel>
          <FormControl componentClass="select"
            value={this.state.voiceProvider || undefined}
            onChange={this.updateField.bind(this, 'voiceProvider')}
          >
            <option value='twilio'>Twilio</option>
            <option value='bandwidth'>Bandwidth</option>
          </FormControl>
        </FormGroup>

        <FieldGroup
          id='customerSendTimeEmailStart'
          type='time'
          label='Email Starting Send Time'
          onChange={this.updateField.bind(this, 'sendTimeEmailStart')}
          value={this.state.sendTimeEmailStart}
        />
        <FieldGroup
          id='customerSendTimeEmailEnd'
          type='time'
          label='Email Ending Send Time'
          onChange={this.updateField.bind(this, 'sendTimeEmailEnd')}
          value={this.state.sendTimeEmailEnd}
        />
        <FieldGroup
          id='customerSendTimeSmsStart'
          type='time'
          label='SMS Starting Send Time'
          onChange={this.updateField.bind(this, 'sendTimeSmsStart')}
          value={this.state.sendTimeSmsStart}
        />
        <FieldGroup
          id='customerSendTimeSmsEnd'
          type='time'
          label='SMS Ending Send Time'
          onChange={this.updateField.bind(this, 'sendTimeSmsEnd')}
          value={this.state.sendTimeSmsEnd}
        />
        <FieldGroup
          id='customerSendTimeVoiceStart'
          type='time'
          label='Voice Starting Send Time'
          onChange={this.updateField.bind(this, 'sendTimeVoiceStart')}
          value={this.state.sendTimeVoiceStart}
        />
        <FieldGroup
          id='customerSendTimeVoiceEnd'
          type='time'
          label='Voice Ending Send Time'
          onChange={this.updateField.bind(this, 'sendTimeVoiceEnd')}
          value={this.state.sendTimeVoiceEnd}
        />

        <Checkbox
          id='sendgridClickTracking'
          inline={true}
          onChange={this.updateCheckbox.bind(this, 'sendgridClickTracking')}
          checked={this.state.sendgridClickTracking}
        >Sendgrid Click Tracking</Checkbox>
        <Checkbox
          id='sendgridOpenTracking'
          inline={true}
          onChange={this.updateCheckbox.bind(this, 'sendgridOpenTracking')}
          checked={this.state.sendgridOpenTracking}
        >Sendgrid Open Tracking</Checkbox>
        <Checkbox
          id='callRecordingsEnabled'
          inline={true}
          onChange={this.updateCheckbox.bind(this, 'callRecordingsEnabled')}
          checked={this.state.callRecordingsEnabled}
        >Call Recordings Enabled</Checkbox>

        <FormGroup controlId="organizationSelect" className='mt-4'>
          <ControlLabel>Organization (optional)</ControlLabel>
          <FormControl componentClass="select"
            value={this.state.organizationId || undefined}
            onChange={this.updateField.bind(this, 'organizationId')}
          >
            <option value={0}>--Select--</option>
            {
              orgs.map(org => <option value={org.id} key={org.id}>{org.name}</option>)
            }
          </FormControl>
        </FormGroup>
        <Button bsStyle='primary' type='submit'>{buttonText}</Button>
      </form>
    );
  }
}

export { CustomerFields }
